/* eslint-disable jsx-a11y/anchor-is-valid */
import {CSSProperties, useCallback, useEffect, useState} from 'react'
import {Outlet, Route, Routes} from 'react-router-dom'
import {
  URL,
  WebSite,
  isMegaPay,
  isAPP,
  AppClearCache,
  brandName,
  onTSP,
} from '../../../_metronic/helpers'
import {hasMegaPayBusinessCapabilities, isDemoInstall} from '../../../_metronic/helpers/brand'
import {LoginMobile} from './components/LoginMobile'
import {Login} from './components/Login'
import {SignInLinkPage} from './completion/SignInLinkPage'
import {useQuery} from 'react-query'
import {SimpleFooter} from '../../pages/dashboard/Simplefooter'
import {AppBackdrop} from '../../theme/AppBackdrop'
import {BrandLockup} from '../../theme/BrandLogo'
import {InstallLoginBox} from '../install-app'
import {isPushWorker} from '../../../serviceWorkerRegistration'
import './components/Login.css'

// The claims below are ASA's own (the same as asatsp.ir's hero); other brands show the neutral text.
const isAsaBrand = hasMegaPayBusinessCapabilities()
const asaAssurances = ['۲۴ ساعته، ۷ روز هفته', 'بدون نیاز به گواهی امضا', 'پشتیبانی تخصصی']

// Staggered entrance order for the site's «hero-in» motion.
const enter = (index: number) => ({'--i': index} as CSSProperties)

const AuthLayout = () => (
  <div className='auth-page-container'>
    <AppBackdrop site />

    <header className='auth-topbar'>
      <BrandLockup href={(isAPP ? URL : WebSite) || '/'} />
      <span className='auth-topbar__badge'>
        <i className='las la-shield-alt' aria-hidden='true' /> {isDemoInstall ? 'نسخهٔ نمایشی' : 'ورود امن'}
      </span>
    </header>

    <main className='auth-main'>
      <section className='auth-intro' aria-labelledby='auth-intro-title'>
        {isAsaBrand && (
          <p className='auth-intro__badge auth-enter' style={enter(0)}>
            <i className='las la-shield-alt' aria-hidden='true' />
            شرکت معتمد مالیاتی نوع اول، با مجوز سازمان امور مالیاتی
          </p>
        )}
        <h2 id='auth-intro-title' className='auth-intro__title auth-enter' style={enter(1)}>
          صورتحساب الکترونیکی،
          <br />
          <span className='asa-text-gradient'>ساده و مطمئن.</span>
        </h2>
        <p className='auth-intro__lead auth-enter' style={enter(2)}>
          وارد پنل {brandName} شوید و صورتحساب‌هایتان را صادر کنید، به سامانه مؤدیان بفرستید و
          نتیجه را همین‌جا پیگیری کنید.
        </p>
        {isAsaBrand && (
          <ul className='auth-intro__points auth-enter' style={enter(3)}>
            {asaAssurances.map((item) => (
              <li key={item}>
                <i className='las la-check' aria-hidden='true' />
                {item}
              </li>
            ))}
          </ul>
        )}
      </section>

      <section className='auth-card auth-enter' style={enter(2)}>
        <Outlet />
        {/* Until the panel is installed on this device, how to install it, under the form. */}
        <InstallLoginBox />
      </section>
    </main>

    <footer className='auth-footer'>
      {isMegaPay && <SimpleFooter />}
      {onTSP && window.location.href.includes('sam') && (
        <div className='mt-2'>
          پشتیبانی:{' '}
          <a href='tel:02151721000' dir='ltr'>
            021-51 72 1000
          </a>
        </div>
      )}
      {onTSP && window.location.href.includes('ava') && (
        <div className='mt-2'>
          پشتیبانی:{' '}
          <a href='tel:02191080080' dir='ltr'>
            021-910 800 80
          </a>
        </div>
      )}
    </footer>
  </div>
)

const AuthPage = () => {
  const [firstLoadDone] = useState(new Date().toString())

  const calculateReloadTime = useCallback(() => {
    if (firstLoadDone) {
      const currentTime = new Date()
      const firstLoadTime = new Date(firstLoadDone)
      const diffInMinutes = (currentTime.getTime() - firstLoadTime.getTime()) / (1000 * 60)

      if (diffInMinutes >= 10) {
        if (isAPP) {
          AppClearCache()
        } else {
          setTimeout(() => {
            window.location.replace(window.location.origin + '/')
          }, 3000)
          // The web push worker caches nothing; removing it would end this device's push.
          navigator.serviceWorker.getRegistrations().then((registrations) => {
            registrations
              .filter((registration) => !isPushWorker(registration))
              .forEach((registration) => {
                registration.unregister()
              })
          })
          caches.keys().then((cacheNames) => {
            cacheNames.forEach((cacheName) => {
              caches.delete(cacheName)
            })
          })
        }
      }
    }
  }, [firstLoadDone])

  useEffect(() => {
    calculateReloadTime()
  }, [calculateReloadTime])

  useQuery('checkusertime', calculateReloadTime)

  return (
    <Routes>
      <Route element={<AuthLayout />}>
        <Route path='login' element={<Login />} />
        <Route path='loginMobile' element={<LoginMobile title={'ورود به کنترل پنل'} />} />
        {/* «ارسال لینک ورود»: the one-time link texted to the user, to set a username and password and sign in. */}
        <Route path='link' element={<SignInLinkPage />} />
        {/* Online sign-up is ASA's own; the bank's install has none. */}
        {isAsaBrand && (
          <Route path='registerMobile' element={<LoginMobile title={'ثبت‌نام آنلاین'} />} />
        )}
        <Route index element={<Login />} />
      </Route>
    </Routes>
  )
}

export {AuthPage}
